import React from 'react';
import {Link} from "react-router-dom";
import OImg from "../OImg";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Grid, Typography} from "@mui/material";
import {isProductBuyable} from "../../utils/helpers";
import {getUrl, PWAUrls} from "../../config/urls";

const TopoListItem = ({i18n, topo, unlocked}) => {
    const link = getUrl(PWAUrls.TOPO, {lng: i18n.language, slug: topo.slug});
    return (
        <Grid container direction="column" justifyContent="space-between" spacing={1}>
            <Grid item xs={12} style={{position: 'relative', paddingLeft: '0px', paddingTop: '4px'}}>
                <Link to={link}>
                    <OImg
                        wrapperClassName={"topoImgContainer"}
                        responsive={false}
                        src={topo.media_big_url}/>
                </Link>

                <div className="guidebook-icon-container text-center">
                    <div className="d-table h-100 w-100">
                        <div className="d-table-cell align-middle">
                            <FontAwesomeIcon icon={['fas', unlocked ? 'star' : 'cart-plus']} />
                        </div>
                    </div>
                </div>
            </Grid>
            <Grid item xs={12}>
                <Link to={link}>
                    <h2 className={'mt-2'}>{topo.label}</h2>
                    <Typography  className={'wysiwyg'} gutterBottom dangerouslySetInnerHTML={{
                        __html: topo.descriptionShort
                    }}/>
                </Link>

                {/*{unlocked && <Button component={Link} to={link} variant="contained" color="primary" className={'text-center mt-4 pt-2 pb-2'}>*/}
                {/*    {t('Ouvrir')}*/}
                {/*</Button>}*/}

                {!unlocked && <Grid container spacing={2}>
                    <Grid item xs={5}> {topo.priceLabel && <label className='tertiary'>{topo.priceLabel}</label>}</Grid>

                    {isProductBuyable(topo.virtualProduct) && <Grid item xs={1}><FontAwesomeIcon icon={['fas', 'mobile-alt']} /></Grid>}
                    {isProductBuyable(topo.physicalProduct) && <Grid item xs={1}><FontAwesomeIcon icon={['fas', 'book']} /></Grid>}

                </Grid>}
            </Grid>
        </Grid>
    );
}
export default compose(
    withTranslation()
)(TopoListItem);
